// extracted by mini-css-extract-plugin
export default {"key-id":"tez9","keyId":"tez9","right-tag":"MGVl","rightTag":"MGVl","none":"nVaL"};